import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'tours-and-experiences-carousel',
  templateUrl: './tours-and-experiences-carousel.component.html',
  styleUrls: ['./tours-and-experiences-carousel.component.scss'],
})
export class ToursAndExperiencesCarouselComponent implements OnInit {
  @Input() attraction: any;
  @Input() IsSeeAll: boolean;
  @Input() city?: string;

  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}

  navigateToServiceListPage() {
    this.analyticsService.trackUnified('service_card_clicked', {
      flow: 'tours_and_experiences',
      outcome: 'success',
      legacy_event_name: 'service_card_clicked',
      carouselId: this.attraction?.carousel_id,
      city: this.city,
    });
    this.navController.navigateForward(
      `tours-and-experiences/service-list/${this.attraction?.carousel_id}/${this.city}`
    );
  }
}
